<template>
    <div class="ah-page audit-flow-page">
        <div class="page-header bottom-margin">
            <div class="ah-container ">
                <div class="title-row">
                    <div class="title">
                        <h1>審核流程設定</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <el-alert v-if="!isEditable" type="warning" :closable="false" style="margin: 0 0 20px 0" center>
                <template slot="title">
                    <div>您所購買的方案不包含自訂審核流程</div>
                </template>
            </el-alert>
            <audit-flow-table type="projectAuditFlowSetting" :setting="auditFlowSettings.projectAuditFlowSetting" @onEdited="onFlowSettingEdited" :editable="isEditable"></audit-flow-table>
            <audit-flow-table type="payoutAuditFlowSetting" :setting="auditFlowSettings.payoutAuditFlowSetting" @onEdited="onFlowSettingEdited" :editable="isEditable"></audit-flow-table>
            <audit-flow-table type="invoiceAuditFlowSetting" :setting="auditFlowSettings.invoiceAuditFlowSetting" @onEdited="onFlowSettingEdited" :editable="isEditable"></audit-flow-table>
        </div>
    </div>
</template>
<script>
import AuditFlowTable from './AuditFlowTable.vue';

export default {
    name: 'AuditFlowPage',
    components: {
        AuditFlowTable,
    },
    data() {
        return {
            isLoading: false,
            auditFlowSettings: {
                invoiceAuditFlowSetting: { isEnable: null, settings: [] },
                payoutAuditFlowSetting: { isEnable: null, settings: [] },
                projectAuditFlowSetting: { isEnable: null, settings: [] },
            },
            pageDatas: { invoiceAuditFlowItems: [], payoutAuditFlowItems: [] },
        };
    },
    created() {
        // 取得流程設定
        this.fetchAuditFlows();
    },
    computed: {
        isAhooAgent() {
            return this.$store.getters['account/isAhooAgent'];
        },
        isSAAdmin() {
            return this.$store.getters['account/isSAAdmin'];
        },
        isEditable() {
            if (this.isSAAdmin || this.isAhooAgent) return true;
            return this.isPayed('S01');
        },
    },
    methods: {
        // 取得所有審核流程清單
        fetchAuditFlows() {
            this.isLoading = true;

            this.$api({
                url: '/Tool/GetAuditFlowTemplates',
                method: 'GET',
            })
                .then((resp) => {
                    console.log(resp);
                    this.auditFlowSettings = resp.data;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        onFlowSettingEdited() {
            this.fetchAuditFlows();
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.audit-flow-page {
    .audit-steps {
        margin: 20px 0;

        .el-step__title {
            color: #333;
            font-weight: bold;
        }

        .el-step__description {
            color: #555;
        }
    }
}
</style>
